<template>
  <RepositoriesConfirm
    :repository
    action-type="unlink"
    @cancel="emit('cancel')"
    @confirmed="emit('unlinked', $event)"
  />
</template>

<script lang="ts" setup>
import { Repository } from '@types'
import RepositoriesConfirm from './RepositoriesConfirm.vue'

type Props = {
  repository: Repository
}

type Emits = {
  cancel: []
  unlinked: [id: string]
}

defineProps<Props>()
const emit = defineEmits<Emits>()
</script>
